import React from "react";

const AudioPlayer = () => {
  return (
    <audio id="backgroundMusic" autoPlay>
        <source src="/assets/sounds/x-sound.wav" type="audio/wav" />
    </audio>
  );
};

export default AudioPlayer;
